"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Bootstrap_1 = require("../Bootstrap");
var Helpers_1 = require("../Helpers");
var ScoreNotifier = /** @class */ (function () {
    function ScoreNotifier(bootstrap) {
        this.$bootstrap = Bootstrap_1.default.getInstance();
        this.$styleNode = null;
        this.$cards = [];
        this.$bootstrap = bootstrap;
        this.initialize();
    }
    ScoreNotifier.prototype.initialize = function () {
        this.createCssClasses();
    };
    ScoreNotifier.prototype.createCard = function (title, description, submitEvent, onCloseEvent) {
        var _this = this;
        if (title === void 0) { title = "You kill an Bug"; }
        if (description === void 0) { description = "You kill 5/12 bugs"; }
        if (submitEvent === void 0) { submitEvent = null; }
        if (onCloseEvent === void 0) { onCloseEvent = null; }
        var div = document.createElement('div');
        var divIconContainer = document.createElement('div');
        var closeIcon = document.createElement('i');
        var h4 = document.createElement('h4');
        var p = document.createElement('p');
        h4.classList.add("h5");
        h4.classList.add("text-center");
        p.classList.add("body1");
        div.id = "bug-notifier-".concat((0, Helpers_1.generateId)());
        divIconContainer.addEventListener("click", function (e) {
            _this.closeCard(div.id, 0);
            if (onCloseEvent) {
                onCloseEvent();
            }
        });
        if (submitEvent) {
            p.style.cursor = "pointer";
            p.addEventListener("click", function (e) {
                submitEvent(_this.$bootstrap.$timer);
            });
        }
        div.classList.add("bug-score-notifier");
        closeIcon.classList.add("fa");
        closeIcon.classList.add("fa-times");
        divIconContainer.classList.add("close-icon");
        h4.innerHTML = title;
        p.innerHTML = description;
        var fragment = document.createDocumentFragment();
        divIconContainer.appendChild(closeIcon);
        div.appendChild(divIconContainer);
        div.appendChild(h4);
        div.appendChild(p);
        fragment.appendChild(div);
        return div;
    };
    ScoreNotifier.prototype.closeCard = function (id, delay) {
        if (id === void 0) { id = ""; }
        if (delay === void 0) { delay = 2000; }
        var actualCard = this.$cards.find(function (e) { return e.id === id; });
        var deb2Hidden = (0, Helpers_1.debounce)(function () {
            actualCard.classList.remove("active");
        }, delay);
        deb2Hidden();
    };
    ScoreNotifier.prototype.removeAllCards = function () {
        this.$cards.forEach(function (e) {
            document.body.removeChild(e);
        });
    };
    ScoreNotifier.prototype.showMessage = function (bugsKilledCount, time) {
        var _this = this;
        if (bugsKilledCount === void 0) { bugsKilledCount = 0; }
        if (time === void 0) { time = "00:00"; }
        var card;
        if (bugsKilledCount < this.$bootstrap.$maxScore) {
            card = this.createCard("Bug kill Score", "".concat(bugsKilledCount, "/").concat(this.$bootstrap.$maxScore, " in ").concat(time));
            card = document.body.appendChild(card);
            this.$cards.push(card);
            var deb2Show = (0, Helpers_1.debounce)(function () {
                card.classList.add("active");
            }, 100);
            deb2Show();
            this.closeCard(card.id, 3000);
        }
        else {
            window.onShowPopupSubmitScore(bugsKilledCount, time);
            card = this.createCard("You are a <b>Bug killer!!!</b>", "<span class=\"underline\">Submit your score</span>", function (_args) { return _this.$bootstrap.onSubmit(_args); }, function () { return window.onCloseSubmitScorePopup(bugsKilledCount, time); });
            var actualCard_1 = document.body.appendChild(card);
            this.$cards.push(actualCard_1);
            var deb2Show = (0, Helpers_1.debounce)(function () {
                actualCard_1.classList.add("active");
            }, 100);
            deb2Show();
        }
    };
    ScoreNotifier.prototype.createCssClasses = function () {
        var styles = "\n      .bug-score-notifier {\n        display: block;\n        padding: 1rem 2rem 1rem 1rem;\n        position: fixed;\n        bottom: -2rem;\n        right: 2rem;\n        -webkit-border-radius: 20px;\n        -moz-border-radius: 20px;\n        border-radius: 20px;\n        -webkit-box-shadow: 10px 10px 10px 1px rgba(5,5,5,0.5);\n        -moz-box-shadow: 10px 10px 10px 1px rgba(5,5,5,0.5);\n        box-shadow: 10px 10px 10px 1px rgba(5,5,5,0.5);\n        opacity: 0;\n        color: #050505;\n        background-color: #f5f5f5;\n        zindex: 999999;\n        transition: all .4s ease-out;\n        text-align: center;\n      }\n      .bug-score-notifier.active {\n        bottom: 2rem;\n        opacity: 1;\n      }\n      .bug-score-notifier .close-icon {\n        display: flex;\n        padding: 0.4rem;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        top: 0.5rem;\n        right: 0.5rem;\n        cursor: pointer;\n        transition: all 0.2s ease-out;\n        border-radius: 5px;\n      }\n      .bug-score-notifier .close-icon i{\n        color: #38abb3;\n      }\n      .bug-score-notifier .close-icon:hover {\n        background-color: #1e1c1c2e;\n      }\n      @media (max-width: 576px) {\n        .bug-score-notifier {\n          position: fixed;\n          right: 0.5rem;\n          left: 0.5rem;\n        }\n      }\n    ";
        var styleNode = window.document.createElement("style");
        styleNode.textContent = styles;
        window.document.head.appendChild(styleNode);
        this.$styleNode = styleNode;
    };
    return ScoreNotifier;
}());
exports.default = ScoreNotifier;
